(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-countdown-timer"] && !Shopify.designMode) return;
  try {
    
  // Make each date be changed whenever the timer shifts
  //Rolls over to next day when the time changes to 4pm EST
  const deadlineTime = 1000 * 60 * 60 * 14; // 2PM EST
  const deliveryDates = {
        us: {
          "2025-12-12":['Dec 19','Dec 18','Dec 16',"Dec 13"],
          "2025-12-13":['Dec 22','Dec 19','Dec 17',"Dec 16"],
          "2025-12-14":['Dec 22','Dec 19','Dec 17',"Dec 16"],
          "2025-12-15":['Dec 22','Dec 19','Dec 17',"Dec 16"],
          "2025-12-16":['Dec 23','Dec 20','Dec 18',"Dec 17"],
          "2025-12-17":["Dec 23","Dec 22","Dec 29","Dec 18"],
          "2025-12-18":["Dec 26","Dec 23","Dec 20","Dec 19"],
          "2025-12-19":["Dec 29","Dec 26","Dec 23","Dec 20"],
          "2025-12-20":["Dec 30","Dec 27","Dec 24","Dec 23"],
          "2025-12-21":["Dec 30","Dec 27","Dec 24","Dec 23"],
          "2025-12-22":["Dec 30","Dec 27","Dec 24","Dec 23"],
          "2025-12-23":["Dec 31","Dec 29","Dec 26","Dec 24"],
          "2025-12-24":["Jan 03","Jan 01","Dec 28","Dec 27"],
          "2026-10-13":["Oct 19","Oct 17","Oct 15","Oct 14"],
          "2026-10-14":["Oct 20","Oct 19","Oct 16","Oct 15"],
          "2026-10-15":["Oct 21","Oct 20","Oct 17","Oct 16"],
          "2026-10-16":["Oct 23","Oct 21","Oct 20","Oct 17"],
          "2026-10-17":["Oct 24","Oct 22","Oct 21","Oct 20"],
          "2026-10-18":["Oct 24","Oct 22","Oct 21","Oct 20"],
          "2026-10-19":["Oct 24","Oct 22","Oct 21","Oct 20"],
          "2026-10-20":["Oct 26","Oct 23","Oct 22","Oct 21"],
          "2026-10-21":["Oct 27","Oct 26","Oct 23","Oct 22"],
          "2026-10-22":["Oct 28","Oct 27","Oct 24","Oct 23"],
          "2026-10-23":["Oct 30","Oct 28","Oct 26","Oct 24"],
          "2026-10-24":["Oct 31","Oct 29","Oct 28","Oct 27"],
          "2026-10-25":["Oct 31","Oct 29","Oct 28","Oct 27"],
          "2026-10-26":["Oct 31","Oct 29","Oct 28","Oct 27"],
          "2026-10-27":["---","Oct 30","Oct 29","Oct 28"],
          "2026-10-28":["---","--","Oct 30","Oct 29"],
          "2026-10-29":["---","--","Oct 31","Oct 30"],
          "2026-10-30":["---","--","----","Oct 31"],


          // Add your dates here in the same format
        },
        canada: {
          "2024-11-23": ["Dec 05", "Nov 28"],
          "2024-11-24": ["Dec 05", "Nov 28"],
          "2024-11-25": ["Dec 06", "Nov 28"],
          "2024-11-26": ["Dec 09", "Nov 29"]
          // Add your dates here in the same format
        },
        international: {
          "2024-11-23": ["Dec 06", "Nov 29"],
          "2024-11-24": ["Dec 06", "Nov 29"],
          "2024-11-25": ["Dec 09", "Nov 29"],
          "2024-11-26": ["Dec 10", "Dec 02"]
          // Add your dates here in the same format
        }
      };
  class CountdownTimer extends HTMLElement {
    constructor(){
      super();
    }
    init (){
      //this.deadlineTime = this.getAttribute('deadline-time');
      this.countdown = new Date(this.schemaTime).getTime();
      this.timer = document.querySelector(".timer");
      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;


      this.timerInterval = null;
      this.startTimer();
      this.updateDates();
    }
    updateDates(){
      //gets the date container
      this.datesContainer = document.querySelector('.datesContainer');
      for (const child of this.datesContainer.children){
      try {
        if(!child.hasAttribute('date-offset')){
          return;
        }
        const offset = parseInt(child.getAttribute('date-offset'));


        const offsetList = [3,2,1,0]


        const offsetDate = getOffsetDate(offsetList[offset-1]);
        child.textContent = offsetDate;
        }catch(e){
          break;
        }

      }
    }
    // Highlights 2-Day / Overnight only while they show a real date,
    // and puts the 2-Day date (or Overnight if 2-Day is closed) in the header pill.
    updateHighlights(){
      const isDate = (t) => /^[A-Za-z]{3}\s+\d{1,2}$/.test((t || '').trim());
      let deliverBy = null;
      ['two-day', 'overnight'].forEach((key) => {
        const dateCell = document.querySelector('.dates[data-featured="' + key + '"]');
        if(!dateCell) return;
        const ok = isDate(dateCell.textContent);
        document.querySelectorAll('[data-featured="' + key + '"]').forEach((el) => {
          el.classList.toggle('is-featured', ok);
          el.classList.toggle('is-muted', !ok);
        });
        if(ok && !deliverBy) deliverBy = dateCell.textContent.trim();
      });
      const pill = document.querySelector('.deliver-by-date');
      if(pill){
        if(deliverBy){
          if(pill.textContent !== deliverBy) pill.textContent = deliverBy;
          pill.style.display = '';
        } else {
          pill.style.display = 'none';
        }
      }
    }
    startTimer(){
     // will need to make this a variable
     // ensure that it isn't in local time.
     this.nextTime = nextDayAt(deadlineTime);
      if(this.timerInterval != null){
          clearInterval(this.timerInterval);
      }
      //Updating this before the first interval
      this.updateDates();
      this.updateHighlights();
      this.timerStep();
     this.timerInterval = setInterval(()=>{
       this.updateDates();
       this.updateHighlights();
       this.timerStep();
       return;
     },this.second);
    }
    padWithLeadingZero (number) {
       if (number < 10) {
           return '0' + number;
       } else {
           return number;
       }
    }
    timerStep(){
      const now = new Date();
      const distance = this.nextTime.getTime() - now.getTime();

      const dayCalc = Math.floor(distance / this.day);
      const hourCalc = Math.floor((distance % this.day)/ this.hour);
      const minuteCalc = Math.floor((distance % this.hour)/ this.minute);
      const secondCalc = Math.floor((distance % this.minute)/ this.second);

      const output = hourCalc + " hrs and " + minuteCalc + " mins";
      this.timer.querySelector(".timer-container").textContent = output;

    }
    connectedCallback(){
      this.init();
    }
    disconnectedCallback(){
      clearInterval(this.timerInterval);
    }
  }
  function nextDayAt(time){
   const today = new Date();
   var nextDay = new Date();
   nextDay.setDate(today.getDate());
   const hrs = today.getHours();
   const mins = today.getMinutes();
   const secs = today.getSeconds();
   nextDay.setTime(nextDay.getTime() + 1000*(-hrs*3600 -mins*60 -secs) + time);
    if(isBeforeNow(nextDay)){
      nextDay.setDate(nextDay.getDate() + 1);
    }
   return nextDay;
  }
  function isBeforeNow(date){
    return Date.now() > date;
  }
  function getOffsetDate(offset){
    const offsetList = [1,2,5,6];
    let new_offset = offsetList[offset];
    const offsetDate = nextDayAt(deadlineTime);
    const date = offsetDate.getFullYear() + "-" + ((parseInt(offsetDate.getMonth())+1)%13) + "-" + offsetDate.getDate();


    offsetDate.setDate(offsetDate.getDate() + new_offset);

    if(deliveryDates["us"][date] !== undefined){
      return deliveryDates["us"][date][offset]
    }


    const output = offsetDate.toLocaleString('default', { month: 'short' }) + " " + offsetDate.getDate();

    return output;
  }
  customElements.define('countdown-timer', CountdownTimer);


  } catch(e) { console.error(e); }
})();
})();
